export default {
  quizzes: [
    {
      id: "chemicalSafetyQuiz",
      title: "Chemical Safety and Safe Cleaning Practices Quiz (PR905)"
    },
    {
      id: "evacuationQuiz",
      title: "Fire Controls and Evacuation Quiz (PR906)"
    },
    {
      id: "foodAllergensQuiz",
      title: "Managing Food Allergens Quiz (PR903)"
    },
    {
      id: "foodSafetyQuiz",
      title: "Food Safety Quiz (PR902)"
    },
    {
      id: "healthAndSafetyQuiz",
      title: "Health & Safety Overview Quiz (PR904)"
    },
    {
      id: "manualHandlingQuiz",
      title: "Manual Handling Quiz (PR907)"
    }
  ].sort((a, b) => a.title.localeCompare(b.title))
};
